export enum MediaTypeEnum {
    Image = 1,
    Video = 2
}